export async function responseError(response: Response) {
    const message = `Response status ${response.status} from ${response.url}`;
    let cause;

    try {
        const text = await response.text();
        try {
            cause = JSON.parse(text);
        } catch {
            cause = text;
        }
    } catch {
        cause = 'Unknown error, failed to parse response body';
    }

    const error = new Error(message, { cause });
    // @ts-expect-error - Property 'statusCode' does not exist on type 'Error'.
    error.statusCode = response.status;
    return error;
}
